import React from "react"

import styles from "./index.module.css"

export const ContentBlueForm: React.FC = () => {
  return (
    <>
      <div>
        <div className={styles.Item}>
          <a href="tel:+74957370101">+7 495 737-01-01</a>
        </div>

        <div className={styles.Item}>
          <a href="mailto:ir@sistema.ru">ir@sistema.ru</a>
        </div>
      </div>
      <div className="d-none d-sm-block" />
    </>
  )
}
